import { Navigate } from "react-router-dom";

// Registrazione email/password disabilitata: i nuovi utenti accedono via Google
// dalla pagina di login. /register reindirizza a /login.
export default function Register() {
    return <Navigate to="/login" replace />;
}
